import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'
import { Arrow } from '@/svgs.js'

class PastEventsSlideshow extends React.Component {
  constructor() {
    super()

    this.vs = null

    this.slideshow = React.createRef()
    this.slideshowSecond = React.createRef()
    this.leftArrow = React.createRef()
    this.rightArrow = React.createRef()
  }
  componentDidMount() {
    const Flickity = require('flickity')
    const slideshow = this.slideshow.current
    const flky = new Flickity(slideshow, {
      contain: true,
      wrapAround: true,
      pageDots: false,
      bgLazyLoad: 2,
      cellAlign: 'center',
      prevNextButtons: false
    })
    const slideshowSecond = this.slideshowSecond.current
    const flkyTwo = new Flickity(slideshowSecond, {
      contain: true,
      wrapAround: true,
      draggable: false,
      pageDots: false,
      bgLazyLoad: 2,
      initialIndex: 1,
      cellAlign: 'center',
      prevNextButtons: false
    })

    setTimeout(() => {
      flkyTwo.resize()
    }, 400)

    const left = this.leftArrow.current
    const right = this.rightArrow.current

    left.addEventListener('click', () => {
      flky.previous()
      flkyTwo.previous()
    })
    right.addEventListener('click', () => {
      flky.next()
      flkyTwo.next()
    })
  }
  render () {
    const {
      previousImages
    } = this.props
    return (
      <div>
        <div className={cx('x experience__wrapper f jcb fw pmy', {
          'not-home': this.props.events
        })}>
          <div className='experience__slideshow mb15 rel x'>
            <div className='slideshow__arrows f fw aic abs z1 bottom right p1'>
              <div className='slideshow__arrows-item rel z1 m05 f jcc aic rotate' ref={this.leftArrow}>
                <Arrow />
              </div>
              <div className='slideshow__arrows-item rel z1 m05 f jcc aic' ref={this.rightArrow}>
                <Arrow />
              </div>
            </div>
            <div className='experience__slideshow-main' ref={this.slideshow}>
              {previousImages.map(photo => (
                <div className='x' key={photo._key}>
                  <div className='experience__slideshow-photo abs z1 x y top left'>
                    <Image imageId={photo.imageId} />
                  </div>
                  <Image className='experience__slideshow-photo-hidden' imageId={previousImages[0].imageId} />
                </div>
              ))}
            </div>
          </div>
          <div className='experience__location x'>
            <div className='experience__location-second x'>
              <div className='experience__slideshow-main' ref={this.slideshowSecond}>
                {previousImages.map(photo => (
                  <div className='x' key={photo._key}>
                    <div className='experience__slideshow-photo abs z1 x y top left'>
                      <Image imageId={photo.imageId} />
                    </div>
                    <Image imageId={previousImages[0].imageId} />
                  </div>
                ))}
              </div>
            </div>
            <div className='px15 pb15 events__outlines ac'>
              <h3 className='caps m0 p0 medium outline o2'>PAST EVENTS</h3>
              <h3 className='caps m0 p0 medium outline o5'>PAST EVENTS</h3>
              <h3 className='caps m0 p0 medium outline black'>PAST EVENTS</h3>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PastEventsSlideshow